import * as t from "io-ts";

export const ConsumerReport = t.type({
  active_ccj: t.number,
  satisfied_ccj: t.number,
  insolvencies: t.boolean,
  credit_score_band: t.string,
  credit_score: t.string,
});

export interface ConsumerReport {
  active_ccj: number;
  satisfied_ccj: number;
  insolvencies: boolean;
  credit_score_band: string;
  credit_score: string;
}
